import { render, staticRenderFns } from "./UserFormUpdate.vue?vue&type=template&id=3fdefba0"
import script from "./UserFormUpdate.vue?vue&type=script&lang=js"
export * from "./UserFormUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports